"use client";

import { c as _c } from "react/compiler-runtime";
import { useCookieConsent } from "@/lib/cookies/useCookieConsent";
import { clsx } from "clsx";
import { BarChart3, Check, Megaphone, Settings as SettingsIcon, Shield, X } from "lucide-react";
import { useState } from "react";
import type { CookieDictionary } from "./types";
interface CookiePreferencesProps {
  dictionary: CookieDictionary;
  onClose: () => void;
}
export function CookiePreferences(t0) {
  const $ = _c(106);
  const {
    dictionary,
    onClose
  } = t0;
  const {
    saveConsent,
    acceptAll,
    rejectAll
  } = useCookieConsent();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      functional: true,
      analytics: false,
      marketing: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [preferences, setPreferences] = useState(t1);
  let t2;
  if ($[1] !== onClose || $[2] !== preferences || $[3] !== saveConsent) {
    t2 = () => {
      saveConsent(preferences);
      onClose();
    };
    $[1] = onClose;
    $[2] = preferences;
    $[3] = saveConsent;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSave = t2;
  let t3;
  if ($[5] !== acceptAll || $[6] !== onClose) {
    t3 = () => {
      acceptAll();
      onClose();
    };
    $[5] = acceptAll;
    $[6] = onClose;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleAcceptAll = t3;
  let t4;
  if ($[8] !== onClose || $[9] !== rejectAll) {
    t4 = () => {
      rejectAll();
      onClose();
    };
    $[8] = onClose;
    $[9] = rejectAll;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleRejectAll = t4;
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex h-12 w-12 items-center justify-center rounded-full bg-terracotta"><SettingsIcon className="h-6 w-6 text-white-cream" /></div>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const t6 = dictionary.preferences?.title || "Pr\xE9f\xE9rences des cookies";
  let t7;
  if ($[12] !== t6) {
    t7 = <h2 className="text-xl font-bold text-forest-green font-serif">{t6}</h2>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = dictionary.preferences?.subtitle || "Choisissez les cookies que vous acceptez";
  let t9;
  if ($[14] !== t8) {
    t9 = <p className="mt-1 text-sm text-wood-natural">{t8}</p>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t7 || $[17] !== t9) {
    t10 = <div className="flex gap-3">{t5}<div>{t7}{t9}</div></div>;
    $[16] = t7;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <X className="h-5 w-5" />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== onClose) {
    t12 = <button onClick={onClose} className="rounded-lg p-2 text-wood-natural transition-colors hover:bg-sand-light" aria-label="Fermer">{t11}</button>;
    $[20] = onClose;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t12) {
    t13 = <div className="border-b border-sand-dark/20 bg-gradient-to-br from-terracotta/10 to-forest-green/10 p-6"><div className="flex items-start justify-between">{t10}{t12}</div></div>;
    $[22] = t10;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="shrink-0"><Shield className="h-6 w-6 text-forest-green" /></div>;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  const t15 = dictionary.preferences?.essential?.title || "Cookies Essentiels";
  let t16;
  if ($[26] !== t15) {
    t16 = <h3 className="font-semibold text-forest-green">{t15}</h3>;
    $[26] = t15;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  const t17 = dictionary.preferences?.essential?.description || "N\xE9cessaires au fonctionnement du site (navigation, pr\xE9f\xE9rences). Ils ne peuvent pas \xEAtre d\xE9sactiv\xE9s.";
  let t18;
  if ($[28] !== t17) {
    t18 = <p className="mt-1 text-sm text-wood-natural">{t17}</p>;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t16 || $[31] !== t18) {
    t19 = <div className="flex gap-3">{t14}<div className="flex-1">{t16}{t18}</div></div>;
    $[30] = t16;
    $[31] = t18;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="shrink-0"><div className="flex h-10 w-10 items-center justify-center rounded-full bg-forest-green/10"><Check className="h-5 w-5 text-forest-green" /></div></div>;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t19) {
    t21 = <div className="rounded-xl border border-sand-dark/20 bg-sand-light p-5"><div className="flex items-start justify-between gap-4">{t19}{t20}</div></div>;
    $[34] = t19;
    $[35] = t21;
  } else {
    t21 = $[35];
  }
  let t22;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="shrink-0"><BarChart3 className="h-6 w-6 text-terracotta" /></div>;
    $[36] = t22;
  } else {
    t22 = $[36];
  }
  const t23 = dictionary.preferences?.analytics?.title || "Cookies Analytiques";
  let t24;
  if ($[37] !== t23) {
    t24 = <h3 className="font-semibold text-forest-green">{t23}</h3>;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  const t25 = dictionary.preferences?.analytics?.description || "Nous aident \xE0 comprendre comment vous utilisez le site (pages visit\xE9es, temps de visite). Donn\xE9es anonymis\xE9es via Vercel Analytics.";
  let t26;
  if ($[39] !== t25) {
    t26 = <p className="mt-1 text-sm text-wood-natural">{t25}</p>;
    $[39] = t25;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t24 || $[42] !== t26) {
    t27 = <div className="flex gap-3">{t22}<div className="flex-1">{t24}{t26}</div></div>;
    $[41] = t24;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = () => setPreferences(_temp2);
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  const t29 = preferences.analytics ? "bg-terracotta" : "bg-sand-dark";
  let t30;
  if ($[45] !== t29) {
    t30 = clsx("relative h-10 w-16 rounded-full transition-all", t29);
    $[45] = t29;
    $[46] = t30;
  } else {
    t30 = $[46];
  }
  const t31 = `${preferences.analytics ? "D\xE9sactiver" : "Activer"} les cookies analytiques`;
  const t32 = preferences.analytics && "translate-x-6";
  let t33;
  if ($[47] !== t32) {
    t33 = clsx("absolute left-1 top-1 h-8 w-8 rounded-full bg-white-cream shadow-md transition-transform duration-300", t32);
    $[47] = t32;
    $[48] = t33;
  } else {
    t33 = $[48];
  }
  let t34;
  if ($[49] !== t33) {
    t34 = <div className={t33} />;
    $[49] = t33;
    $[50] = t34;
  } else {
    t34 = $[50];
  }
  let t35;
  if ($[51] !== t30 || $[52] !== t31 || $[53] !== t34) {
    t35 = <div className="shrink-0"><button onClick={t28} className={t30} aria-label={t31}>{t34}</button></div>;
    $[51] = t30;
    $[52] = t31;
    $[53] = t34;
    $[54] = t35;
  } else {
    t35 = $[54];
  }
  let t36;
  if ($[55] !== t27 || $[56] !== t35) {
    t36 = <div className="rounded-xl border border-sand-dark/20 bg-white-cream p-5"><div className="flex items-start justify-between gap-4">{t27}{t35}</div></div>;
    $[55] = t27;
    $[56] = t35;
    $[57] = t36;
  } else {
    t36 = $[57];
  }
  let t37;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <div className="shrink-0"><Megaphone className="h-6 w-6 text-terracotta" /></div>;
    $[58] = t37;
  } else {
    t37 = $[58];
  }
  const t38 = dictionary.preferences?.marketing?.title || "Cookies Marketing";
  let t39;
  if ($[59] !== t38) {
    t39 = <h3 className="font-semibold text-forest-green">{t38}</h3>;
    $[59] = t38;
    $[60] = t39;
  } else {
    t39 = $[60];
  }
  const t40 = dictionary.preferences?.marketing?.description || "Permettent l'utilisation de services tiers comme reCAPTCHA pour s\xE9curiser le formulaire de contact.";
  let t41;
  if ($[61] !== t40) {
    t41 = <p className="mt-1 text-sm text-wood-natural">{t40}</p>;
    $[61] = t40;
    $[62] = t41;
  } else {
    t41 = $[62];
  }
  let t42;
  if ($[63] !== t39 || $[64] !== t41) {
    t42 = <div className="flex gap-3">{t37}<div className="flex-1">{t39}{t41}</div></div>;
    $[63] = t39;
    $[64] = t41;
    $[65] = t42;
  } else {
    t42 = $[65];
  }
  let t43;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = () => setPreferences(_temp3);
    $[66] = t43;
  } else {
    t43 = $[66];
  }
  const t44 = preferences.marketing ? "bg-terracotta" : "bg-sand-dark";
  let t45;
  if ($[67] !== t44) {
    t45 = clsx("relative h-10 w-16 rounded-full transition-all", t44);
    $[67] = t44;
    $[68] = t45;
  } else {
    t45 = $[68];
  }
  const t46 = `${preferences.marketing ? "D\xE9sactiver" : "Activer"} les cookies marketing`;
  const t47 = preferences.marketing && "translate-x-6";
  let t48;
  if ($[69] !== t47) {
    t48 = clsx("absolute left-1 top-1 h-8 w-8 rounded-full bg-white-cream shadow-md transition-transform duration-300", t47);
    $[69] = t47;
    $[70] = t48;
  } else {
    t48 = $[70];
  }
  let t49;
  if ($[71] !== t48) {
    t49 = <div className={t48} />;
    $[71] = t48;
    $[72] = t49;
  } else {
    t49 = $[72];
  }
  let t50;
  if ($[73] !== t45 || $[74] !== t46 || $[75] !== t49) {
    t50 = <div className="shrink-0"><button onClick={t43} className={t45} aria-label={t46}>{t49}</button></div>;
    $[73] = t45;
    $[74] = t46;
    $[75] = t49;
    $[76] = t50;
  } else {
    t50 = $[76];
  }
  let t51;
  if ($[77] !== t42 || $[78] !== t50) {
    t51 = <div className="rounded-xl border border-sand-dark/20 bg-white-cream p-5"><div className="flex items-start justify-between gap-4">{t42}{t50}</div></div>;
    $[77] = t42;
    $[78] = t50;
    $[79] = t51;
  } else {
    t51 = $[79];
  }
  let t52;
  if ($[80] !== t21 || $[81] !== t36 || $[82] !== t51) {
    t52 = <div className="max-h-[60vh] overflow-y-auto p-6"><div className="space-y-4">{t21}{t36}{t51}</div></div>;
    $[80] = t21;
    $[81] = t36;
    $[82] = t51;
    $[83] = t52;
  } else {
    t52 = $[83];
  }
  const t53 = dictionary.rejectAll || "Tout refuser";
  let t54;
  if ($[84] !== handleRejectAll || $[85] !== t53) {
    t54 = <button onClick={handleRejectAll} className="flex-1 rounded-lg border border-sand-dark bg-white-cream px-4 py-2.5 text-sm font-medium text-wood-natural transition-all hover:bg-sand-light sm:flex-none">{t53}</button>;
    $[84] = handleRejectAll;
    $[85] = t53;
    $[86] = t54;
  } else {
    t54 = $[86];
  }
  const t55 = dictionary.acceptAll || "Tout accepter";
  let t56;
  if ($[87] !== handleAcceptAll || $[88] !== t55) {
    t56 = <button onClick={handleAcceptAll} className="flex-1 rounded-lg border border-sand-dark bg-white-cream px-4 py-2.5 text-sm font-medium text-forest-green transition-all hover:bg-sand-light sm:flex-none">{t55}</button>;
    $[87] = handleAcceptAll;
    $[88] = t55;
    $[89] = t56;
  } else {
    t56 = $[89];
  }
  let t57;
  if ($[90] !== t54 || $[91] !== t56) {
    t57 = <div className="flex gap-3">{t54}{t56}</div>;
    $[90] = t54;
    $[91] = t56;
    $[92] = t57;
  } else {
    t57 = $[92];
  }
  const t58 = dictionary.preferences?.save || "Enregistrer mes pr\xE9f\xE9rences";
  let t59;
  if ($[93] !== handleSave || $[94] !== t58) {
    t59 = <button onClick={handleSave} className="rounded-lg bg-terracotta px-6 py-2.5 text-sm font-semibold text-white-cream shadow-lg transition-all hover:bg-terracotta-light hover:shadow-xl">{t58}</button>;
    $[93] = handleSave;
    $[94] = t58;
    $[95] = t59;
  } else {
    t59 = $[95];
  }
  let t60;
  if ($[96] !== t57 || $[97] !== t59) {
    t60 = <div className="border-t border-sand-dark/20 bg-sand-light p-6"><div className="flex flex-col gap-3 sm:flex-row sm:justify-between">{t57}{t59}</div></div>;
    $[96] = t57;
    $[97] = t59;
    $[98] = t60;
  } else {
    t60 = $[98];
  }
  let t61;
  if ($[99] !== t13 || $[100] !== t52 || $[101] !== t60) {
    t61 = <div className="relative max-h-[90vh] w-full max-w-2xl overflow-hidden rounded-2xl border border-sand-dark/20 bg-white-cream shadow-2xl animate-scale-in" onClick={_temp}>{t13}{t52}{t60}</div>;
    $[99] = t13;
    $[100] = t52;
    $[101] = t60;
    $[102] = t61;
  } else {
    t61 = $[102];
  }
  let t62;
  if ($[103] !== onClose || $[104] !== t61) {
    t62 = <div className="fixed inset-0 z-[100] flex items-center justify-center bg-charcoal/50 p-4 backdrop-blur-sm animate-fade-in" onClick={onClose}>{t61}</div>;
    $[103] = onClose;
    $[104] = t61;
    $[105] = t62;
  } else {
    t62 = $[105];
  }
  return t62;
}
function _temp3(prev_0) {
  return {
    ...prev_0,
    marketing: !prev_0.marketing
  };
}
function _temp2(prev) {
  return {
    ...prev,
    analytics: !prev.analytics
  };
}
function _temp(e) {
  return e.stopPropagation();
}